import { useNavigate } from "react-router";
import SimpleFrame from "../../components/simple";
import { DataContext } from "../../context/dataProvider";
import { useContext, useEffect, useState } from "react";
import { SUBSCRIPTION_TYPE } from "../../context/types";
import styles from './style.module.css';
function SettingsPage() {
  const context = useContext(DataContext);
  const [loading, setLoading] = useState<boolean>(true)
  const navigation = useNavigate();
  const handleClickStartSettings = () => {
    navigation('/select-device');
  }

  useEffect(() => {
    const buyAccess = async () => {
      if (context && context.user) {
        const userServer = context.user.userServer;
        // Проверяем, есть ли активная подписка (тестовая или платная)
        const hasActiveSubscription = userServer && 
          new Date(userServer.subscriptionEndDate) >= new Date();
        
        if (!hasActiveSubscription) {
          setLoading(true);
          await context.buyAccess(SUBSCRIPTION_TYPE.TEST);
          setLoading(false);
        } else {
          setLoading(false);
        }
      } else if (context) {
        setLoading(true);
        await context.buyAccess(SUBSCRIPTION_TYPE.TEST);
        setLoading(false);
      }
    }
    buyAccess();
  }, [context]);

  return (
    <div className="settings">
      <div className={styles.backgroundContainer}>
          <img src="/images/settings-background.png" alt=""/>
        </div>
        <SimpleFrame title="Настройка" subtitle="Займет всего 3 минуты" buttonLabel="Начать настройку" loading={loading} handleClick={handleClickStartSettings}></SimpleFrame>
    </div>
  );
}

export default SettingsPage;